import * as React from 'react';

function SvgCamera2(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M5 8c0-1.657 2.343-3 4-3V4a4 4 0 00-4 4z' />
			<path d='M12.318 3h2.015C15.253 3 16 3.746 16 4.667v6.666c0 .92-.746 1.667-1.667 1.667h-2.015A5.97 5.97 0 019 14a5.972 5.972 0 01-3.318-1H1.667C.747 13 0 12.254 0 11.333V4.667C0 3.747.746 3 1.667 3H2a1 1 0 011-1h1a1 1 0 011 1h.682A5.97 5.97 0 019 2c1.227 0 2.367.368 3.318 1zM2 4.5a.5.5 0 10-1 0 .5.5 0 001 0zM14 8A5 5 0 104 8a5 5 0 0010 0z' />
		</svg>
	);
}

export default SvgCamera2;
